<div class="py-dialog">
<div style="display: flex;align-items: end;flex-direction:column;">
    <button nz-button
            (click)="kapa()"
            nz-wave
            style="position: absolute;"
            [routerLink]="'/🏠/🔑'"
            nzType="primary"
            nzDanger
            nzShape="circle"
            nzSize="small"><nz-icon nzType="close" />
    </button>
</div>
<div class="ui small header m-1">
    Kişi Seçici
</div>
<!-- NOT:  Arama Kutusu -->
<div class="ui right labeled left icon input mini fluid"
     *ngIf="!saltOkunur ? true:false"
     style="margin-left: auto;margin-right: auto;max-width: 100%;width:470px;margin-top: 1rem;">
    <i class="search icon"></i>
    <input type="text" placeholder="Tanıdık Bul" [(ngModel)]="aramaMetni"
            style="border-top-left-radius: 50vh;border-bottom-left-radius: 50vh;"
            (keyup.enter)="degistiFilitre($event);">
    <a class="ui tag blue label"
       style="border-top-right-radius: 50vh;border-bottom-right-radius: 50vh;"
       (click)="degistiFilitre($event);">
        Ara
    </a>

</div>

<div class="scrolling content p-3 m-0 overflow-y-auto overflow-x-hidden">
    <!-- NOT:  Kimse Bulunamadı -->
    @if (!saltOkunur ? kullanicilarIstek.liste.length<1:kisiler.length<1) {
                         <div
                         class="ui placeholder segment">
        <div class="ui icon header">
            @if (kullanicilarIstek.mesgul) {
            <i class="spinner loading icon"></i>
            } @else {
            <i class="archway icon"></i>
            }

            {{ kullanicilarIstek.mesgul ? 'Okunuyor':'Kimseler Yok' }}
        </div>
</div>
}
<!-- NOT: Kullanıcı Listesi -->
<div class="ui middle aligned selection divided list"
     style="text-align: left;">


    <!-- <div class="item" *ngFor="let k of kisiler.slice().reverse(); trackBy:trackByMethod"
                [class.active]="miKisiListesinde(k)" (click)="tiklandiKullaniciKarti(k)">
                <div class="right floated content" *ngIf="(FikoYT.aktifKullaniciJson | async)._id !== k._id ">

                </div>
                <img class="ui avatar image" style="object-fit: cover;" alt="Üye Resmi" width="32" height="32"
                    [src]="FikoYT.fapiUrl+'/fapi/FikoYT.sistem.'+k?._id+'.profilResmi?boyut=?x96'">
                <div class="content">
                    <a class="ui black text" style="color: var(--py-metin); text-shadow: none;">{{ k?.adSoyad }}</a>
                </div>
            </div> -->
    <div class="mb-3">
        @for ( k of !saltOkunur ? kisiler ?? []:kisiler; track $index) {
        <a class="ui image mini label"
           (click)="tiklandiKullaniciKarti(k)">
            <img style="width: 24px !important;object-fit: cover;"
                 src="{{FikoYT.env.adres.fapiUrl}}/fikoyt.com.FikoYT.sistem.kullanici.{{k?._id?.toString()}}.profilResmi?boyut=148x?&t={{zmnRsm}}&quality=20">
            {{ k?.isim ?? '' }} {{k?.soyIsim ?? '' }}
        </a>

        <!-- <div class="item"
         [class.active]="miKisiListesinde(k)"
         (click)="tiklandiKullaniciKarti(k)">
        <div class="right floated content"
             *ngIf="FikoYT.kimlik.aktifKullaniciJson()?._id == k._id ">
            (Siz)
        </div>
        <img class="ui avatar image"
             style="object-fit: cover;"
             alt="Üye Resmi"
             width="32"
             height="32"
             src="{{FikoYT.env.adres.fapiUrl}}/fikoyt.com.FikoYT.sistem.kullanici.{{k?._id?.toString()}}.profilResmi?boyut=148x?&t={{zmnRsm}}&quality=20">
        <div class="content">
            <a class="ui black text"
               style="color: var(--py-metin); text-shadow: none;">{{ k?.isim ?? '' }} {{k?.soyIsim ?? '' }}</a>
        </div>
    </div> -->
        }
    </div>
    <!-- [style.display]="miKisiListesinde(k) ? 'none':'list-item'" -->
    @for ( k of !saltOkunur ? kullanicilarIstek.liste ?? []:kisiler; track $index) {
    <!-- @if (!miKisiListesinde(k)){ -->
    <div class="item"
         [class.active]="miKisiListesinde(k)"
         (click)="tiklandiKullaniciKarti(k)">
        <div class="right floated content"
             *ngIf="FikoYT.kimlik.aktifKullaniciJson()?._id == k._id ">
            (Siz)
        </div>
        <img class="ui avatar image"
             style="object-fit: cover;"
             alt="Üye Resmi"
             width="32"
             height="32"
             src="{{FikoYT.env.adres.fapiUrl}}/fikoyt.com.FikoYT.sistem.kullanici.{{k?._id?.toString()}}.profilResmi?boyut=148x?&t={{zmnRsm}}&quality=20">
        <div class="content">
            <a class="ui black text"
               style="color: var(--py-metin); text-shadow: none;">{{ k?.isim ?? '' }} {{k?.soyIsim ?? '' }}</a>
        </div>
    </div>
    <!-- } -->
    }
</div>



@if (kullanicilarIstek.sayfalama.sayi){
<nz-row nzJustify="center"
        style="margin-top: 1em;position: -webkit-sticky;position: sticky;bottom: 5px;">
    <div
         style="/*max-width: 960px;*/row-gap: 10px;width: 100%;display: flex;flex-wrap: wrap;justify-content: center;column-gap: 10px;margin-right:1em;">

        <nz-pagination #sayfalayici
                       [nzSimple]="true"
                       [nzTotal]="kullanicilarIstek.sayfalama.toplamKayitSayisi"
                       style="background: var(--py-sayfalama-arka);padding: 0px 10px;border-radius: 2em;box-shadow: var(--py-sayfalama-golge);"
                       [nzPageSize]="kullanicilarIstek.sayfalama.sayi"
                       (nzPageSizeChange)="kullanicilarIstek.sayiDegistir($event);"
                       nzSize="small"
                       [nzPageSizeOptions]="[5, 10, 15]"
                       [nzPageIndex]="kullanicilarIstek.sayfalama.sayfa"
                       (nzPageIndexChange)="kullanicilarIstek.sayfaDegistir($event);"
                       nzShowSizeChanger
                       nzShowQuickJumper
                       [nzDisabled]="kullanicilarIstek.mesgul"></nz-pagination>
    </div>
</nz-row>
}





<!-- NOT:  Devam Et Butonu -->
<!-- @if (!kullanicilarIstek.tumKayitlarAlindi) {
@if (kullanicilarIstek.liste.length>0 && !saltOkunur ? true:false) {
<button class="ui blue elastic fluid button p-2"
        [class.loading]="kullanicilarIstek.mesgul"
        (click)="kullanicilarIstek.sonrakiSayfaEkle();">
    Devam Et
</button>
}
}
</div> -->

<div class="mt-3"
     style="display: flex;align-items: end;flex-direction:row;">
    <button class="ui red icon button mini"
            style="vertical-align: top;"
            nz-wave
            nz-popconfirm
            nzPopconfirmTitle="Tüm Etiketlenenler Silinecek Eminmisiniz?"
            nzOkText="Evet"
            nzCancelText="İptal"
            nzOkDanger
            (nzOnConfirm)="kisiler = [];CD.detectChanges()">
        <i class="trash icon"></i>
    </button>
    <div class="ui right red labeled animated fade icon button mini"
         (click)="kapa();"
         style="vertical-align: top;">
        <div class="visible content">
            Kapat
        </div>
        <div class="hidden content">
            Kapat
        </div>
        <i class="close icon"></i>
    </div>
    <span style="flex: 1;"></span>
    <div class="ui green labeled animated fade icon button mini"
         (click)="kaydetTiklandi()"
         *ngIf="!saltOkunur"
         style="vertical-align: top;">
        <div class="visible content">
            Kaydet
        </div>
        <div class="hidden content">
            Kaydet
        </div>
        <i class="check icon"></i>
    </div>
</div>
</div>